import { defineStyleConfig } from "@chakra-ui/react";

const Tag = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    container: {
      bg: "secondary.900",
      color: "secondary.100",
    },
    closeButton: {
      color: "secondary.100",
      opacity: 1,
    },
    _dark: {
      container: {
        bg: "secondary.100",
        color: "secondary.800",
      },
      closeButton: {
        color: "secondary.900",
        opacity: 1,
      },
    },
  },
  variants: {
    select: {
      container: {
        paddingLeft: 4,
        paddingTop: 1.5,
        paddingBottom: 1.5,
        fontSize: "lg",
        borderRadius: "lg",
        bg: "secondary.900",
        color: "secondary.50",
      },
      closeButton: {
        color: "secondary.50",
        opacity: 1,
        paddingLeft: 4,
        paddingRight: 4,
      },
    },
  },
});

export default Tag;
